export const INSTANCE_PATH = 'users';

export enum RESPONSE_ERROR {
    DUPLICATED_USERNAME = 'DUPLICATED_USERNAME',
}

export enum ROLE {
    SUPER_ADMIN = 'SUPER_ADMIN',
    USER = 'USER',
}

export enum PERMISSION {
    PAYMENTS_VIEW = 'PAYMENTS_VIEW',
    PAYMENTS_CREATE_PAY_IN = 'PAYMENTS_CREATE_PAY_IN',
    PAYMENTS_CREATE_PAY_OUT = 'PAYMENTS_CREATE_PAY_OUT',
    PAYMENTS_EDIT_PAY_IN_STATUS = 'PAYMENTS_EDIT_PAY_IN_STATUS',
    PAYMENTS_EDIT_PAY_OUT_STATUS = 'PAYMENTS_EDIT_PAY_OUT_STATUS',
    PAYMENTS_EDIT_PAY_IN = 'PAYMENTS_EDIT_PAY_IN',
    PAYMENTS_EDIT_PAY_OUT = 'PAYMENTS_EDIT_PAY_OUT',
    PAYMENTS_CHANGE_TERMINATE_STATUS = 'PAYMENTS_CHANGE_TERMINATE_STATUS',
    PAYMENTS_BULK_CHANGE_ACCOUNT = 'PAYMENTS_BULK_CHANGE_ACCOUNT',
    PAYMENTS_BULK_PAY = 'PAYMENTS_BULK_PAY',
    PAYMENTS_BULK_FAIL = 'PAYMENTS_BULK_FAIL',

    ACCOUNTS_VIEW = 'ACCOUNTS_VIEW',
    ACCOUNTS_CREATE_PAY_IN = 'ACCOUNTS_CREATE_PAY_IN',
    ACCOUNTS_CREATE_PAY_OUT = 'ACCOUNTS_CREATE_PAY_OUT',
    ACCOUNTS_STATEMENT_UPLOAD = 'ACCOUNTS_STATEMENT_UPLOAD',
    ACCOUNTS_EDIT = 'ACCOUNTS_EDIT',
    ACCOUNTS_ACTIVATE = 'ACCOUNTS_ACTIVATE',
    ACCOUNTS_INACTIVATE = 'ACCOUNTS_INACTIVATE',
    ACCOUNTS_RESET_INACTIVATED_REASON = 'ACCOUNTS_RESET_INACTIVATED_REASON',
    ACCOUNTS_DELETE = 'ACCOUNTS_DELETE',
    ACCOUNTS_AUTO_PARSER_STATUS_VIEW = 'ACCOUNTS_AUTO_PARSER_STATUS_VIEW',
    ACCOUNTS_AUTO_PARSER_ACTIVATE = 'ACCOUNTS_AUTO_PARSER_ACTIVATE',
    ACCOUNTS_AUTO_PARSER_INACTIVATE = 'ACCOUNTS_AUTO_PARSER_INACTIVATE',

    ACCOUNT_DRAFTS_MANAGE = 'ACCOUNT_DRAFTS_MANAGE',
    ACCOUNT_DRAFTS_REVIEW = 'ACCOUNT_DRAFTS_REVIEW',

    ACCOUNT_POOLS_VIEW = 'ACCOUNT_POOLS_VIEW',
    ACCOUNT_POOLS_MERCHANT_VIEW = 'ACCOUNT_POOLS_MERCHANT_VIEW',
    ACCOUNT_POOLS_CREATE = 'ACCOUNT_POOLS_CREATE',
    ACCOUNT_POOLS_EDIT = 'ACCOUNT_POOLS_EDIT',
    ACCOUNT_POOLS_DELETE = 'ACCOUNT_POOLS_DELETE',

    PAYMENT_METHODS_VIEW = 'PAYMENT_METHODS_VIEW',
    PAYMENT_METHODS_CREATE = 'PAYMENT_METHODS_CREATE',
    PAYMENT_METHODS_EDIT = 'PAYMENT_METHODS_EDIT',

    MERCHANTS_VIEW = 'MERCHANTS_VIEW',
    MERCHANTS_EDIT = 'MERCHANTS_EDIT',
    MERCHANT_ACCOUNT_POOLS_MANAGE = 'MERCHANT_ACCOUNT_POOLS_MANAGE',

    SETTLEMENTS_VIEW = 'SETTLEMENTS_VIEW',
    SETTLEMENTS_CREATE = 'SETTLEMENTS_CREATE',

    AGENTS_VIEW = 'AGENTS_VIEW',
    AGENTS_EDIT = 'AGENTS_EDIT',
    AGENTS_STATISTICS_VIEW = 'AGENTS_STATISTICS_VIEW',
    AGENTS_STATISTICS_VIEW_COMMISSION = 'AGENTS_STATISTICS_VIEW_COMMISSION',
    AGENTS_STATISTICS_VIEW_AFFILIATE_COMMISSION = 'AGENTS_STATISTICS_VIEW_AFFILIATE_COMMISSION',
    AGENTS_PREPAY_CREATE = 'AGENTS_PREPAY_CREATE',
    AGENTS_SEND_SUPPORT_MESSAGE = 'AGENTS_SEND_SUPPORT_MESSAGE',
    AGENTS_SEND_FINANCE_MESSAGE = 'AGENTS_SEND_FINANCE_MESSAGE',

    PREPAYS_CREATE = 'PREPAYS_CREATE',

    POST_BACK_HISTORIES_VIEW = 'POST_BACK_HISTORIES_VIEW',
    POST_BACK_HISTORIES_RESEND = 'POST_BACK_HISTORIES_RESEND',

    COMPLAINTS_VIEW = 'COMPLAINTS_VIEW',
    COMPLAINTS_VIEW_NEW = 'COMPLAINTS_VIEW_NEW',
    COMPLAINTS_ALL = 'COMPLAINTS_ALL',
    COMPLAINTS_CREATE = 'COMPLAINTS_CREATE',
    COMPLAINTS_EDIT = 'COMPLAINTS_EDIT',
    COMPLAINTS_CHANGE_STATUS = 'COMPLAINTS_CHANGE_STATUS',
    COMPLAINTS_CHANGE_CHECKED_STATUS = 'COMPLAINTS_CHANGE_CHECKED_STATUS',
    COMPLAINTS_CHANGE_TERMINATE_STATUS = 'COMPLAINTS_CHANGE_TERMINATE_STATUS',

    COMPLAINT_POST_BACKS_HISTORIES_VIEW = 'COMPLAINT_POST_BACKS_HISTORIES_VIEW',
    COMPLAINT_POST_BACKS_HISTORIES_RESEND = 'COMPLAINT_POST_BACKS_HISTORIES_RESEND',

    TRANSACTIONS_VIEW = 'TRANSACTIONS_VIEW',
    TRANSACTIONS_IDENTIFIER_VIEW = 'TRANSACTIONS_IDENTIFIER_VIEW',
    TRANSACTIONS_CREATE = 'TRANSACTIONS_CREATE',
    TRANSACTIONS_NOT_ACTIVATED_VIEW = 'TRANSACTIONS_NOT_ACTIVATED_VIEW',
    TRANSACTIONS_FAKE_VIEW = 'TRANSACTIONS_FAKE_VIEW',
    TRANSACTIONS_CHANGE_STATUS = 'TRANSACTIONS_CHANGE_STATUS',
    TRANSACTIONS_CHANGE_FAKE = 'TRANSACTIONS_CHANGE_FAKE',
    TRANSACTIONS_CHANGE_TERMINATE_STATUS = 'TRANSACTIONS_CHANGE_TERMINATE_STATUS',
    TRANSACTIONS_DELETE = 'TRANSACTIONS_DELETE',

    PROXIES_VIEW = 'PROXIES_VIEW',
    PROXIES_MANAGE = 'PROXIES_MANAGE',

    SETTINGS_CONVERSION_VIEW = 'SETTINGS_CONVERSION_VIEW',
    SETTINGS_CONVERSION_EDIT = 'SETTINGS_CONVERSION_EDIT',
    SETTINGS_CONVERSION_EDIT_ACTIVITY = 'SETTINGS_CONVERSION_EDIT_ACTIVITY',
    SETTINGS_PREPAY_VIEW = 'SETTINGS_PREPAY_VIEW',
    SETTINGS_PREPAY_EDIT = 'SETTINGS_PREPAY_EDIT',
    SETTINGS_ANTI_FRAUD_VIEW = 'SETTINGS_ANTI_FRAUD_VIEW',
    SETTINGS_ANTI_FRAUD_EDIT = 'SETTINGS_ANTI_FRAUD_EDIT',
    SETTINGS_MERCHANT_USER_ID_BLACK_LIST_VIEW = 'SETTINGS_MERCHANT_USER_ID_BLACK_LIST_VIEW',
    SETTINGS_MERCHANT_USER_ID_BLACK_LIST_EDIT = 'SETTINGS_MERCHANT_USER_ID_BLACK_LIST_EDIT',
}
